<template>
    <main class="container">
        <h1>Loxone Library Review Guideline</h1>
        <p>We are convinced that the Loxone Library will change the way partners and customers integrate 3rd party products with Loxone. The library enables you to share your templates with the world and we are excited that the community is an integral part of it.</p>
        <p>To ensure quality, functionality, ease of use and safety every template submitted to the Loxone library is being checked and approved by Loxone. This guideline introduces you to the rules and best practices to successfully publish a template in the Loxone library.</p>
        <h3>Language & Naming conventions</h3>
        <ul>
            <li>Both Template names and descriptions as well as the template itself has to be provided in english.</li>
            <li>The name of the template has to clearly describe which product is associated with the template. If more than one product is integrated through the template they have to be listed in the ‘supported devices’ section.</li>
            <li>Ensure that the description includes all information that is required to use the template.</li>
        </ul>
        <h3>Purpose & Quality</h3>
        <ul>
            <li>Products and devices supported through a template must be safe to use in home and building environments and comply with common safety standards such as CE conformity, NRTL approval (UL, ETL), electrical safety and thermal protection.</li>
            <li>Products and devices supported through a template must not imitate core loxone products such as the Miniserver and its Extensions.</li>
            <li>Products and devices supported through a template that are used in critical home and building infrastructure (such as base lighting, heating, security) must communicate through a reliable interface to ensure functionality and quality that is expected in professionally installed environments.</li>
            <li>Make sure to test your template for full functionality</li>
        </ul>
        <p>Loxone reserves the right to reject or remove any templates at any time without further notice.</p>
        <h3>Additional requirements for Vendor Templates</h3>
        <p>If a template is published as a vendor template, the following additional requirements are mandatory:</p>
        <ul>
            <li>The template must be provided with a corresponding Loxone Config sample file</li>
            <li>The vendor has to provide support details (e-mail address and phone number) that are listed in the Loxone Library</li>
            <li>The vendor agrees to keep the template up to date to ensure compatibility with the vendor device/system and the Loxone system</li>
        </ul>
        <h3>The following video shows how you create a new template and upload it to the library in just a few steps.</h3>
        <br/>

        <div class="youtube_iframe">
            <iframe class="ql-video" width="560" height="315" src="https://www.youtube.com/embed/nZyg7AtXYSc" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
        <h1>FAQs</h1>
        <p>
            <b>I've put a lot of time into creating XYZ templates - are you also considering charging for templates?</b><br/>
            At this point, the Loxone library is and remains free of charge.
        </p>
        <p>
            <b>Who do I contact if the template doesn't work or I don't know how to use it?</b><br/>
            Each entry to the library comes with a support section with contact details on who to reach out to when a template is not working. Please be aware that all templates come free of charge and support may not be mandatory.
        </p>
    </main>
</template>

<style lang="scss" scoped>
    h1 {
        margin-bottom: 5px;
        margin-top: 60px;
    }
    h3 {
        margin-bottom: 0px;
        margin-top: 30px;
    }

    ul{
        margin-top: 5px;
    }
    .youtube_iframe{
            position: relative;
            padding-bottom: 67%;
            padding-top: 0;
            height: 0;
            overflow: hidden;

            .ql-video{
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
            }
        }
    @media screen and (max-width: 1200px){
        .container{
            max-width: 960px!important;
            padding: 0 20px;
        }
    }
</style>